import {
  Component,
  Input,
  Output,
  EventEmitter,
  inject,
  ViewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AttachmentsDialogComponent } from '../../../../post-trade/components/attachments-dialog/attachments-dialog.component';
import { FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { bulkActionOptions } from '../../../../lib/rb-grid-lib';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-bulk-actions',
  templateUrl: './bulk-actions.component.html',
  styleUrls: ['./bulk-actions.component.scss'],
  imports: [
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatTooltipModule,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class BulkActionsComponent {
  @ViewChild('pageSelector', { static: false })
  public pageSelector: MatCheckbox;

  @Input() gridType = '';
  @Input() rowSelector = '';
  @Input() pagesSelected = [];
  @Input() selectedTradeList = [];
  @Input() selectedChecked = {};
  @Input() skip = 0;
  @Input() gridData = {
    data: [],
    headers: [],
    subHead: [],
    total: 0,
  };
  @Input() state;
  @Input() generateQueryData;
  @Output() getGridData = new EventEmitter();
  @Output() toggleGridLoading = new EventEmitter();
  @Output() bulkSelect = new EventEmitter();
  @Output() pageSelect = new EventEmitter();
  @Output() resetSelect = new EventEmitter();

  pageSelectControl = false;
  bulkSelectControl = false;
  bulkActionControl = new FormControl();
  bulkActionOptions = bulkActionOptions;
  dialog = inject(MatDialog);

  toggleBulkSelect(ev) {
    if (ev.checked) {
      if (this.pageSelector && this.pageSelector.checked) {
        this.pageSelector.toggle();
      }
      this.bulkSelectControl = true;
    } else {
      this.bulkSelectControl = false;
      ev['reset'] = true;
    }
    this.bulkSelect.emit(ev);
  }

  togglePageSelect(ev) {
    this.pageSelect.emit(ev);
  }

  resetBulkAction(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    this.bulkActionControl.setValue('');
  }

  executeBulkAction() {
    // Build a list of IDs for bulk actions
    const bulkActionIds: Array<string> = [];
    this.selectedTradeList.map(trade => {
      bulkActionIds.push(trade[this.rowSelector]);
    });

    const dialogData = {
      bulk: true,
      bulkActionIds: bulkActionIds,
      bulkAction: this.bulkActionControl.value,
      profileType: this.gridType,
      recordCount: this.selectedTradeList.length,
    };

    if (this.bulkSelectControl) {
      dialogData['queryData'] = this.generateQueryData();
      dialogData['recordCount'] = this.gridData.total;
    }

    const bulkActionDialog = this.dialog.open(AttachmentsDialogComponent, {
      panelClass: 'app-bulk-action-dialog',
      data: dialogData,
    });

    bulkActionDialog.afterClosed().subscribe(resp => {
      if (resp !== 'cancel') {
        if (this.pageSelector.checked) {
          this.pageSelector.toggle();
        }
        this.selectedTradeList = [];
        this.selectedChecked = {};
        this.bulkSelectControl = false;
        this.pageSelectControl = false;
        this.pagesSelected = [];
        this.bulkActionControl.setValue(null);
        this.toggleGridLoading.emit(true);
        this.resetSelect.emit();
        this.getGridData.emit();
      }
    });
  }
}
